import { DEFAULT_PRODUCT_CATEGORY_SLUG } from "@/shared/constants/product"
import { Lookbook } from "@/types/lookbook"
import { Product } from "@/types/product"

export function extractIdFromProductSlugAndId(slug: string): Product['id'] {
  // Пример: white-shirt-1726 → "1726"
  const parts = slug.split("-")
  return Number(parts[parts.length - 1])
}

export function makeProductPageUrl(product: Product): string {
  // Формируем URL для страницы товара
  return `/shop/${product?.category?.slug ?? DEFAULT_PRODUCT_CATEGORY_SLUG}/${product?.slug}-${product.id}`
}

export function extractIdFromLookbookSlugAndId(slug: string): Lookbook['id'] {
  // Пример: summer-collection-45 → "45"
  const parts = slug.split("-")
  return Number(parts[parts.length - 1])
}

export function makeLookbookPageUrl(lookbook: Lookbook): string {
  // Формируем URL для страницы лукбука
  return `/shop/lookbook/${lookbook.slug}-${lookbook.id}`
}